export default import.meta.ROLLDOWN_FILE_URL_VXn_h3_bOvNykhEjXYMbxA